import { PlaceOfPerson } from "../../types/placeOfPerson";
import { BaseConnectionService } from "./baseConnectionService";

class PlaceOfPersonConnectionService extends BaseConnectionService<PlaceOfPerson> {
  constructor() {
    super("places-of-person");
  }
}

export const placeOfPersonConnectionService =
  new PlaceOfPersonConnectionService();
